import * as React from 'react'
import { Modal, WidgetWrapper } from 'uxp/components'
import { IUIPropertyDefinitionMap, IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { SelectableItem, selectUIProps } from '../../../common/SelectableItem'
import { ContainerProperty, extractContainerProperties } from '../../../common/ui-props/ContainerProperty'

import './styles.scss'
import { TextFieldProperty } from '../../../common/ui-props/TextFieldProperty'
import { RichTextProperty } from '../../../common/ui-props/RichTextProperty'
import MarkdownView from '../../../common/Markdown/MarkdownView'
import { ColorProperty, SimpleColorProperty } from '../../../common/ui-props/ColorProperty'
import { TextProperty } from '../../../common/ui-props/TextProperty'
import { IContextData, useInitialContextData } from '../../../../hooks/useContextData'
import { replaceWithData } from '../../../../util'
const sampleText = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. `

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {
    const [view, setView] = React.useState(false);

    let uiProps = props?.uiProps || {};
    const XPRProps: IUIPropertyDefinitionMap = {
        "container": ContainerProperty({
            background: {
                color: "#ffffff",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        'title': TextProperty({ text: 'Title Goes Here', color: '#000000', size: '18px' }, 'Title',),
        'markup': RichTextProperty('Description', sampleText),
        'markupColor': SimpleColorProperty('Text Color', '#000000')
    }

    let { text: title = 'Title Goes Here', color: titleColor = '#000000', size: titleFont = '18px' } = uiProps?.title || {};
    let { styles: containerStyles } = extractContainerProperties(uiProps.container);

    let [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)

    const { isLoading, initialContextData } = useInitialContextData(props)

    title = replaceWithData(title, contextData)


    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    return (
        <WidgetWrapper className='content-card-widget-template wd-widget-wrapper'>
            <div className="bg" style={containerStyles}></div>
            <SelectableItem
                style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'container')}
                contextData={contextData}
            >
                <div className='container'>
                    <div className='title-bar-wrapper'>
                        <div className="uxp-widget-title-bar uxp-drag-handler">
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'title')}
                                contextData={contextData}
                            >
                                <div className="title-section">
                                    <span className="txt" style={{ color: titleColor, fontSize: `${titleFont}` }}>{title}</span>
                                </div>
                            </SelectableItem>
                        </div>
                    </div>

                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'markup', 'markupColor')}
                        contextData={contextData}
                    >
                        <div className="data-area-container-wrapper" style={{color: uiProps.markupColor || '#000000' }} onClick={() => {
                            if (!props.designer || props?.designer?.mode != 'preview') {
                                setView(true)
                            }
                        }}>
                            <MarkdownView className='markup' text={uiProps?.markup || sampleText} />
                        </div>
                    </SelectableItem>
                </div>
            </SelectableItem>
            <Modal
                title={title}
                show={view}
                onClose={() => setView(false)}
            >
                <MarkdownView className='markup' text={uiProps?.markup || sampleText} /> 
            </Modal>
        </WidgetWrapper>
    )
})

registerCardTemplate({
    id: 'content-card',
    name: 'Content Card',
    description: 'To show long form contentClipped text in the card. Tape to open in long view ',
    template: XPR,
    icon: generateIconProp('box'),
    complexity: 'easy',
});
